// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ofgt","containerItemsCenter":"Skeleton_containerItemsCenter__1hlBF"};